export const journeyCopyDe = {
    profileCompleteTitle: "Profil abgeschlossen",
    profileCompleteStatusLabel: "Profil gespeichert",
    profileCompleteConsentDescription: "Ihre Profildaten wurden gespeichert. Als Nächstes prüfen wir die Einwilligung.",
    profileCompleteSetupDescription:
        "Ihre Profildaten wurden gespeichert. Als Nächstes benötigen wir Ihre Behandlungseinrichtung.",
    profileCompleteFormsDescription:
        "Ihre Profildaten wurden gespeichert. Als Nächstes können Sie Ihre Formulare ausfüllen.",
    profileCompleteDiaryDescription: "Ihre Profildaten wurden gespeichert.",
    consentCompleteTitle: "Einwilligung abgeschlossen",
    consentCompleteStatusLabel: "Einwilligung unterschrieben",
    consentCompleteSetupDescription:
        "Vielen Dank! Ihre Einwilligungen wurden gespeichert. Als Nächstes benötigen wir noch ein paar weitere Angaben.",
    consentCompleteFormsDescription:
        "Ihre Einwilligungen wurden gespeichert. Als Nächstes können Sie Ihre Formulare ausfüllen.",
    consentCompleteDiaryDescription: "Ihre Einwilligungen wurden gespeichert.",
    setupCompleteTitle: "Einrichtung abgeschlossen",
    setupCompleteStatusLabel: "Einrichtung gespeichert",
    setupCompleteConsentDescription: "Als Nächstes prüfen wir die Einwilligung.",
    setupCompleteFormsDescription:
        "Vielen Dank! Ihre Daten sind gespeichert. Als Nächstes benötigen wir noch ein paar weitere Angaben.",
    setupCompleteDiaryDescription: "Ihre Behandlungsdetails sind bereit.",
    formCompleteTitle: "Formular abgeschlossen",
    formCompleteNextDescription: "Ihre Antwort wurde gespeichert. Sie können mit dem nächsten Eintrag fortfahren.",
    formCompleteAllDoneDescription:
        "Ihre Antwort wurde gespeichert. Sie sind vorerst auf dem neuesten Stand. Sie können Ihre Ergebnisse ansehen.",
    formCompleteAllCaughtUpTitle: "Alles auf dem neuesten Stand",
    formCompleteAllCaughtUpNextDue: (date) => `Nächste Fälligkeit am ${date}`,
    formCompleteNextEntryDue: (scheduleLabel, date) =>
        `Ihr Eintrag für ${scheduleLabel.toLowerCase()} ist am ${date} fällig.`,
    formCompleteStatusSuffix: "abgeschlossen",
    continueToNextForm: "Weiter",
    goToConsent: "Zur Einwilligung",
    goToSetup: "Zur Einrichtung",
    knowProcedureDateYetTitle: "Kennen Sie das Datum schon?",
    knowProcedureDateYetMessage:
        "Tragen Sie Ihr Behandlungsdatum ein, sobald Sie es wissen, damit die Nachfragen zu Ihrer Behandlung passen.",
    addProcedureDate: "Behandlungsdatum hinzufügen",
    addHospitalNumber: "Krankenhausnummer hinzufügen",
    addSide: "Seite hinzufügen",
    addEventDate: (eventPhrase) => `Datum der ${eventPhrase} hinzufügen`,
    reviewConsent: "Einwilligung prüfen",
    shortcutsHeading: "Noch zu erledigen:",
    goToForms: "Zu den Formularen",
    goToYourDiary: "Zu Ihrem Tagebuch",
    goToYourResults: "Zu Ihren Ergebnissen",
    seeCharts: "Diagramme ansehen",
    phaseProfile: "Profil",
    phaseSetup: "Einrichtung",
    phaseConsent: "Einwilligung",
    phaseForms: "Formulare",
    phaseDiary: "Tagebuch",
    setupHospitalNumber: "Krankenhausnummer",
    setupProcedureDate: "Eingriffsdatum",
    setupSide: "Seite",
    loadingProgress: "Fortschritt wird geladen...",
    progressTitle: "Ihr Fortschritt",
    dismissProgress: "Fortschritt schließen",
    currentStage: "Aktuelle Phase",
    stepProgressAriaLabel: (stepLabel) => `Fortschritt: ${stepLabel}`,
    stepOf: "von",
    nextStep: "Nächster Schritt",
    formsDoneCount: (done, total) => `Erledigte Formulare: ${done} von ${total}`,
    diaryStillSettingUp: "Ihr Tagebuch wird noch eingerichtet. Das kann einen Moment dauern.",
    tryAgain: "Erneut versuchen",
};
